// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"f37bd888","413":"8105191c","433":"815c492c","554":"8b04bdd8"}[chunkId] + ".chunk.js";
};